import { FormControl, FormLabel } from "@chakra-ui/react";
import React from "react";

const MyBoolean = ({ value, onChange, required, label, placeholder }) => {
  return (
    <FormControl isRequired={required}>
      <FormLabel fontSize="sm">{label}</FormLabel>
      <input
        placeholder={placeholder}
        value={value}
        onClick={() => onChange(!value)}
        checked={value}
        variant="outline"
        size="md"
        borderRadius="md"
        bgColor={"white"}
        type="checkbox"
        _placeholder={{ color: "gray.400" }}
      />
    </FormControl>
  );
};
export default MyBoolean;
